/* eslint-disable class-methods-use-this */

import { Controller } from 'stimulus';
import loadCss from '../helpers/loadCss';

const ACCESS_TOKEN = window.app.mapboxToken;

class MapSelect extends Controller {
  connect() {
    this.map = null;
    this.mapboxgl = null;
    this.markers = [];

    this.loadJs().then((module) => {
      this.loadCss().then(() => {
        this.mapboxgl = module.default;
        this.mapboxgl.accessToken = ACCESS_TOKEN;

        this.createMap();
        this.createListeners();

        this.applyOldValue();
      });
    });
  }

  createMap() {
    this.map = new this.mapboxgl.Map({
      container: this.mapTarget,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [5.6162634, 52.3213594],
      zoom: 5,
    });
  }

  createListeners() {
    this.map.on('click', this.onMapClick.bind(this));
  }

  refresh() {
    this.map.resize();
  }

  applyOldValue() {
    const oldValue = this.data.get('old');

    if (oldValue) {
      const coordinates = oldValue.split(',');

      if (coordinates.length !== 2) {
        return;
      }

      const lngLat = {
        lng: coordinates[1],
        lat: coordinates[0],
      };

      this.addMarkerOnLngLat(lngLat);
      this.outputCoordinatesTextForLngLat(lngLat);
      this.map.setCenter(lngLat);
    }
  }

  onMapClick(event) {
    this.removeAllMarkers();

    const { lngLat } = event;

    this.addMarkerOnLngLat(lngLat);

    this.map.setCenter(event.lngLat);

    this.outputCoordinatesTextForLngLat(event.lngLat);
  }

  addMarkerOnLngLat(lngLat) {
    const marker = new this.mapboxgl.Marker()
      .setLngLat(lngLat)
      .addTo(this.map);

    this.markers.push(marker);
  }

  outputCoordinatesTextForLngLat(lngLat) {
    const { lng, lat } = lngLat;
    const lngFormatted = typeof lng === 'number' ? lng.toFixed(5) : lng;
    const latFormatted = typeof lat === 'number' ? lat.toFixed(5) : lat;

    this.helpTarget.setAttribute('hidden', 'hidden');

    this.coordinatesTarget.textContent = this.coordinatesTarget.getAttribute('data-text')
      .replace('[point]', `${latFormatted}, ${lngFormatted}`);
    this.inputTarget.value = `${latFormatted},${lngFormatted}`;

    const changeEvent = new Event('change');
    changeEvent.lngLat = lngLat;
    this.inputTarget.dispatchEvent(changeEvent);
  }

  onSearchKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.onSearchClick();
    }
  }

  onSearchClick() {
    const { value } = this.searchTarget;

    const search = encodeURIComponent(value);

    const apiUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${search}.json?access_token=${ACCESS_TOKEN}`;

    $.ajax({
      url: apiUrl,
      dataType: 'json',
      success: (res) => {
        if (typeof res.features !== 'undefined' && Array.isArray(res.features)) {
          this.centerOnFeatures(res.features);
        }
      },
    });
  }

  centerOnFeatures(features) {
    const primaryFeature = features.length ? features[0] : null;

    if (!primaryFeature) {
      return;
    }

    const center = typeof primaryFeature.center !== 'undefined' ? primaryFeature.center : null;

    if (!center) {
      return;
    }

    this.map.setCenter(center);
    this.map.setZoom(9);
  }

  removeAllMarkers() {
    this.markers.forEach((marker, index) => {
      marker.remove();
      this.markers.splice(index, 1);
    });
  }

  loadJs() {
    return import(/* webpackChunkName: "mapbox" */ 'mapbox-gl');
  }

  loadCss() {
    return loadCss('/front_assets/css/mapbox-gl.min.css');
  }
}

MapSelect.targets = [
  'map',
  'search',
  'help',
  'input',
  'coordinates',
];

export default MapSelect;
